/*
===============================================================================================================
                                 Copyright 2024-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

const filterFunctionForPages = (
  condition,
  processingEnabled,
  isAdminReviewMode,
  isIntegrated,
  portalActive,
  canCreateTestOrders,
  isReturnMethodsEnabled,
  hasRefundsEnabled,
  canManageUsers,
  hasGiftReturnsEnabled,
) => {
  switch (condition) {
    case 'processingEnabled':
      return processingEnabled;
    case 'hiddenInReviewMode':
      return !isAdminReviewMode;
    case 'isIntegrated':
      return isIntegrated;
    case 'portalActive':
      return portalActive;
    case 'canCreateTestOrders':
      return canCreateTestOrders;
    case 'canViewReturnMethods':
      return isReturnMethodsEnabled;
    case 'hasRefundsEnabled':
      return hasRefundsEnabled;
    case 'canManageUsers':
      return canManageUsers;
    case 'hasGiftReturnsEnabled':
      return hasGiftReturnsEnabled;
    default:
      return true;
  }
};

const filterSectionsPages = ({
  sections,
  processingEnabled,
  isAdminReviewMode,
  isIntegrated,
  portalActive,
  canCreateTestOrders,
  isReturnMethodsEnabled,
  hasRefundsEnabled,
  canManageUsers,
  hasGiftReturnsEnabled,
}) => {
  const filteredSections = sections?.map((section) => {
    if (section.withFilters) {
      const pagesWithModifiedSubItems = section.pages.map((page) => {
        if (page.subItems) {
          const filteredSubItems = page.subItems.filter((subItem) => filterFunctionForPages(
            subItem.condition,
            processingEnabled,
            isAdminReviewMode,
            isIntegrated,
            portalActive,
            canCreateTestOrders,
            isReturnMethodsEnabled,
            hasRefundsEnabled,
            canManageUsers,
            hasGiftReturnsEnabled,
          ));
          return {
            ...page,
            subItems: filteredSubItems,
          };
        }
        return page;
      });

      const filteredSection = {
        ...section,
        pages: pagesWithModifiedSubItems.filter((page) => filterFunctionForPages(
          page.condition,
          processingEnabled,
          isAdminReviewMode,
          isIntegrated,
          portalActive,
          canCreateTestOrders,
          isReturnMethodsEnabled,
          hasRefundsEnabled,
          canManageUsers,
          hasGiftReturnsEnabled,
        )),
      };
      if (filteredSection.pages.length === 0) {
        return null;
      }

      return filteredSection;
    }
    return section;
  });

  return filteredSections;
};

const getNavigationSections = ({
  structure,
  isAdminReviewMode,
  processingEnabled,
  isIntegrated,
  portalActive,
  canCreateTestOrders,
  isReturnMethodsEnabled,
  hasRefundsEnabled,
  canManageUsers,
  hasGiftReturnsEnabled,
}) => {
  const filteredOptions = {
    topSection: [],
    bottomSection: [],
  };

  // filtering out topSection sections' pages
  const topSectionsWithFilteredPages = filterSectionsPages({
    sections: structure.topSection,
    processingEnabled,
    isAdminReviewMode,
    isIntegrated,
    portalActive,
    canCreateTestOrders,
    isReturnMethodsEnabled,
    hasRefundsEnabled,
    canManageUsers,
    hasGiftReturnsEnabled,
  });

  // filtering out bottomSection sections' pages
  const bottomSectionsWithFilteredPages = filterSectionsPages({
    sections: structure.bottomSection,
    processingEnabled,
    isAdminReviewMode,
    isIntegrated,
    portalActive,
    canCreateTestOrders,
    isReturnMethodsEnabled,
    hasRefundsEnabled,
    canManageUsers,
    hasGiftReturnsEnabled,
  });

  filteredOptions.bottomSection = bottomSectionsWithFilteredPages?.filter(Boolean);
  filteredOptions.topSection = topSectionsWithFilteredPages?.filter(Boolean);

  return filteredOptions;
};

export default getNavigationSections;
